module.exports = __webpack_public_path__ + "static/media/gol.2f7f97b7.png";